class drawbackCtrl {
    constructor($scope, operationService) {
        let activeSel = function () {
            if (operationService.hasPermit('drawback_info')) {
                return 1
            }
            if (operationService.hasPermit('confirm_drawback_info')) {
                return 2
            }
            if (operationService.hasPermit('drawback_statistics')) {
                return 3
            }
            return -1
        }

        $scope.active = activeSel()
        $scope.typeChange = function typeChange(v){
            $scope.active = v
        }
    }
}

drawbackCtrl.$inject = ['$scope', 'operationService']
export default drawbackCtrl



// WEBPACK FOOTER //
// ./src/app/input/specialInvoiceCertification/drawback/drawbackCtrl.js